/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

var dialogDefaultProps = {
  closeBtn: true,
  closeOnEscKeydown: void 0,
  closeOnOverlayClick: void 0,
  destroyOnClose: false,
  draggable: false,
  footer: true,
  header: true,
  mode: "modal",
  placement: "top",
  preventScrollThrough: true,
  showInAttachedElement: false,
  showOverlay: true,
  theme: "default"
};

export { dialogDefaultProps };
//# sourceMappingURL=defaultProps.js.map
